import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import TfGenQuery from "../../../../model/TfGenQuery";
import TfGenResult from "../../../../model/TfGenResult";
import { GeneratorCategory, GeneratorFlagEnum } from "../../../../model/generator/GeneratorTypes";
import _http_service from "../../../../services/HttpService";
import _image_service from "../../../../services/ImageService";

const _preload_images = [
    'chase/assets/zap.png',
    'chase/assets/tf_victim.png'
];

const _default_query: TfGenQuery = {
    category: GeneratorCategory[0],
    extinct: GeneratorFlagEnum.INCLUDE,
    mythical: GeneratorFlagEnum.INCLUDE,
    casarokanUnique: GeneratorFlagEnum.EXCLUDE,
    modifier: "NONE"
};


const TfGeneratorPage = () => {

    const [query, setQuery] = useState<TfGenQuery>(_default_query);
    const navigate = useNavigate();
    const [result, setResult] = useState<TfGenResult | undefined>(undefined);

    useEffect(() => {
        _preload_images.forEach(src => {
            const img = new Image();
            img.src = _image_service.getCdnImageSrc(src);
        });
    }, []);

    const getQuickResult = async (): Promise<void> => {
        try {
            const result = await _http_service.getTransformationQuickResult("quick");
            setResult(result);
            navigate("/tf-generator/result");
        } catch {
            navigate("/error", { replace: false });
        }
    }

    const getGeneratorResult = async (): Promise<void> => {
        try {
            const result = await _http_service.getTransformationGeneratorResult(query);
            setResult(result);
            navigate("/tf-generator/result");
        } catch {
            navigate("/error", { replace: false });
        }
    }

    const getQRResult = async (): Promise<void> => {
        try {
            const result = await _http_service.getTransformationQuickResult("qr");
            setResult(result);
        } catch {
            navigate("/error", { replace: false });
        }
    }

    const resetQuery = (): void => {
        setQuery(_default_query);
    }
    
    
    return (
        <Outlet context={{query, setQuery, result, setResult, getQuickResult, getGeneratorResult, resetQuery, getQRResult}}/>
    );
}

export default TfGeneratorPage;

export type TfGeneratorPageContext = {
    query: TfGenQuery;
    setQuery: (query: TfGenQuery) => void;
    result: TfGenResult | undefined;
    setResult: (result: TfGenResult) => void;
    getQuickResult: () => Promise<void>;
    getGeneratorResult: (query: TfGenQuery) => Promise<void>;
    resetQuery: () => void;
    getQRResult: () => Promise<void>;
 }